// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import clientApi from '~/apis/client';
import { IBodyUpdate } from '~/utils/interface/common';
import { IParamDetailClient, IQueryParamClient } from '~/utils/interface/client';
import {
  CREATE_CLIENT,
  DELETE_CLIENT,
  GET_DETAIL_CLIENT,
  GET_LIST_CLIENT,
  UPDATE_CLIENT,
} from '~/utils/constants/actionType';

export const getListClient = createAsyncThunk(
  GET_LIST_CLIENT,
  async (params: IQueryParamClient, { rejectWithValue }) => {
    try {
      const resp = await clientApi.getListClient(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDetailClient = createAsyncThunk(
  GET_DETAIL_CLIENT,
  async (params: IParamDetailClient, { rejectWithValue }) => {
    try {
      const resp = await clientApi.getDetailClient(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createClient = createAsyncThunk(CREATE_CLIENT, async (formData: FormData, { rejectWithValue }) => {
  try {
    const resp = await clientApi.createClient(formData);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateClient = createAsyncThunk(
  UPDATE_CLIENT,
  async (params: IBodyUpdate<FormData>, { rejectWithValue }) => {
    try {
      const resp = await clientApi.updateClient(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteClient = createAsyncThunk(DELETE_CLIENT, async (id: string, { rejectWithValue }) => {
  try {
    const resp = await clientApi.deleteClient(id);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
